import safeLocalStorage from 'safe-localstorage';

export default () => {
  const estimatedSubCount = safeLocalStorage.get('subscriptions/estimatedSubCount');

  return {
    estimatedSubCount: estimatedSubCount ? parseInt(estimatedSubCount, 10) : 1,
    subscriptions: [],
    subscriptionsLoaded: false,
    subUpdateError: null,
    plans: [],
    loading: false,
    plansLoading: false,
  };
};
